import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';

export default function getAuthToken(messageBus: SDKMessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('authToken')) {
        return;
    }

    return function(): Promise<string> {
        return messageBus.sendRequest<string>('authToken', Maybe.nothing()).then(response => {
            return response.value;
        });
    };
}
